jQuery(document).ready(function($){
// $('.install-banner__slider').slick({
// 		slidesToShow: 1,
// 		slidesToScroll: 1,
// 		arrows: false,
// 		dots: true,
// 		infinite: true,
// 		vertical: true,
// 		verticalSwiping: true,
// 		autoplay: true,
// 		autoplaySpeed: 3000,
// 		speed: 600,
// 		cssEase: 'linear',
// 		responsive: [
// 			{ breakpoint: 750, settings: { slidesToShow: 1, vertical: true, verticalSwiping: true } }
// 		]
// 	});
 });
(function ($) {

  function initInstallBannerSlider() {

    $('.install-banner__slider').each(function () {

      var $slider = $(this);

      // Destroy existing Slick before changing direction
      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('unslick');
      }

      if (window.innerWidth <= 767) {

        // =========================
        // MOBILE - HORIZONTAL
        // =========================
        $slider.slick({
          slidesToShow: 1,
          slidesToScroll: 1,

          arrows: false,
          dots: true,

          infinite: true,

          vertical: false,
          verticalSwiping: false,

          autoplay: true,
          autoplaySpeed: 3000,

          speed: 600,
          cssEase: 'linear'
        });

      } else {

        // =========================
        // DESKTOP - VERTICAL
        // =========================
        $slider.slick({
          slidesToShow: 1,
          slidesToScroll: 1,

          arrows: false,
          dots: true,

          infinite: true,

          vertical: true,
          verticalSwiping: true,

          autoplay: true,
          autoplaySpeed: 3000,

          speed: 600,
          cssEase: 'linear'
        });

      }

    });

  }


  // Initial load
  $(document).ready(function () {
    initInstallBannerSlider();
  });


  // Reinitialize on resize
  var resizeTimer;

  $(window).on('resize', function () {

    clearTimeout(resizeTimer);

    resizeTimer = setTimeout(function () {
      initInstallBannerSlider();
    }, 250);

  });


  // Shopify Theme Editor
  $(document).on('shopify:section:load', function () {
    initInstallBannerSlider();
  });

})(jQuery);

(function ($) {

  'use strict';

  function initMobileSliders() {

    var isMobile = window.innerWidth <= 767;


    /*
     * ==========================================
     * FEATURE BADGES SLIDER
     * ==========================================
     */
    $('.feature-badges__inner').each(function () {

      var $slider = $(this);

      if (isMobile) {

        if (!$slider.hasClass('slick-initialized')) {

          $slider.slick({

            slidesToShow: 1,
            slidesToScroll: 1,

            arrows: false,
            dots: false,

            infinite: true,

            autoplay: true,
            autoplaySpeed: 3000,

            speed: 600,

            swipe: true,
            touchMove: true,

            cssEase: 'ease'

          });

        }

      } else {

        if ($slider.hasClass('slick-initialized')) {
          $slider.slick('unslick');
        }

      }

    });


    /*
     * ==========================================
     * EXPLORE APPLIANCE CATEGORIES SLIDER
     * ==========================================
     */
    $('.appliance-cats__grid').each(function () {

      var $slider = $(this);

      if (isMobile) {

        if (!$slider.hasClass('slick-initialized')) {

          $slider.slick({

            slidesToShow: 1,
            slidesToScroll: 1,

            arrows: false,
            dots: false,

            infinite: true,

            autoplay: true,
            autoplaySpeed: 3000,

            speed: 600,

            swipe: true,
            touchMove: true,

            adaptiveHeight: false,

            cssEase: 'ease',

            centerMode: true

          });

        }

      } else {

        if ($slider.hasClass('slick-initialized')) {
          $slider.slick('unslick');
        }

      }

    });

  }


  /*
   * ==========================================
   * INITIAL LOAD
   * ==========================================
   */
  $(document).ready(function () {
    initMobileSliders();
  });


  /*
   * ==========================================
   * WINDOW RESIZE
   * ==========================================
   */
  var mobileSliderResizeTimer;

  $(window).on('resize', function () {

    clearTimeout(mobileSliderResizeTimer);

    mobileSliderResizeTimer = setTimeout(function () {

      initMobileSliders();

    }, 250);

  });


  /*
   * ==========================================
   * SHOPIFY THEME EDITOR
   * ==========================================
   */
  $(document).on('shopify:section:load', function () {

    initMobileSliders();

  });


})(jQuery);

/*product card slider in mobile*/
(function ($) {

  function initProductGridSlider() {

    $('.product-grid').each(function () {

      var $slider = $(this);

      if (window.innerWidth <= 767) {

        // Initialize only on mobile
        if (!$slider.hasClass('slick-initialized')) {

          $slider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 3000,
            speed: 600,
            cssEase: 'linear'
          });

        }

      } else {

        // Remove Slick on desktop
        if ($slider.hasClass('slick-initialized')) {
          $slider.slick('unslick');
        }

      }

    });

  }

  // Initial load
  $(document).ready(function () {
    initProductGridSlider();
  });

  // Handle resize
  var resizeTimer;

  $(window).on('resize', function () {

    clearTimeout(resizeTimer);

    resizeTimer = setTimeout(function () {
      initProductGridSlider();
    }, 250);

  });

})(jQuery);

/*deliver option price moveing js*/
(function () {
  var CACHE_KEY = 'fpob_prices_{{ product.id }}';
  var prices = {};
  var busy = false;

  // Load saved prices so they show instantly
  try { prices = JSON.parse(localStorage.getItem(CACHE_KEY)) || {}; } catch (e) { prices = {}; }

  function save() {
    try { localStorage.setItem(CACHE_KEY, JSON.stringify(prices)); } catch (e) {}
  }

  // The "(+ $499.00)" element the app shows next to "Delivery Type"
  function headingPriceEl(wrap) {
    var box = wrap.parentElement;
    for (var i = 0; i < 4 && box; i++) {
      var nodes = box.querySelectorAll('*');
      for (var j = 0; j < nodes.length; j++) {
        var el = nodes[j];
        if (wrap.contains(el) || el.contains(wrap)) continue;
        if (el.children.length === 0 && /\$\s*[\d,]+/.test(el.textContent)) return el;
      }
      box = box.parentElement;
    }
    return null;
  }

  function readPrice(wrap) {
    var el = headingPriceEl(wrap);
    if (!el) return null;
    el.style.display = 'none';
    var m = el.textContent.match(/\$\s*[\d,]+(?:\.\d{1,2})?/);
    return m ? m[0].replace(/\s/g, '') : null;
  }

  function addPrices(wrap) {
    wrap.querySelectorAll('.fpob-rb-check-item').forEach(function (item) {
      var input = item.querySelector('input[type="radio"]');
      if (!input) return;
      var price = prices[input.value.trim()];
      if (!price) return;
      var span = item.querySelector('.fpob-rb-price');
      if (!span) {
        span = document.createElement('span');
        span.className = 'fpob-rb-price';
        item.appendChild(span);
      }
      if (span.textContent !== price) span.textContent = price;
    });
  }

  // Wait until the app shows a new price (max 1s)
  function waitForPrice(wrap, oldPrice, cb) {
    var t = 0;
    (function poll() {
      var p = readPrice(wrap);
      if ((p && p !== oldPrice) || t >= 1000) return cb(p);
      t += 20;
      setTimeout(poll, 20);
    })();
  }

  // Read fresh prices from the app in the background
  function collect(wrap) {
    if (busy || wrap.dataset.pricesDone) return;
    busy = true;
    wrap.dataset.pricesDone = '1';

    var radios = Array.prototype.slice.call(wrap.querySelectorAll('input[type="radio"]'));
    var original = radios.filter(function (r) { return r.checked; })[0] || null;
    var last = readPrice(wrap);
    var i = 0;

    (function next() {
      if (i >= radios.length) {
        if (original) { original.click(); }
        else {
          radios.forEach(function (r) { r.checked = false; });
          radios[0] && radios[0].dispatchEvent(new Event('change', { bubbles: true }));
        }
        busy = false;
        save();
        addPrices(wrap);
        return;
      }
      var r = radios[i++];
      r.click();
      waitForPrice(wrap, last, function (p) {
        if (p) { prices[r.value.trim()] = p; last = p; addPrices(wrap); }
        next();
      });
    })();
  }

  function init() {
    var wrap = document.querySelector('.fpob-rb-items-wrap');
    if (!wrap) return false;
    addPrices(wrap);   // instant from saved prices
    readPrice(wrap);   // keep heading price hidden
    collect(wrap);     // refresh in background
    return true;
  }

  // Keep price correct when the customer changes option
  document.addEventListener('change', function (e) {
    if (busy) return;
    var wrap = e.target.closest && e.target.closest('.fpob-rb-items-wrap');
    if (!wrap) return;
    setTimeout(function () {
      var p = readPrice(wrap);
      if (p && e.target.checked) { prices[e.target.value.trim()] = p; save(); }
      addPrices(wrap);
    }, 100);
  });

  // Run as soon as the app adds the options
  if (!init()) {
    var mo = new MutationObserver(function () {
      if (!busy && init()) {}
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  } else {
    new MutationObserver(function () { if (!busy) init(); })
      .observe(document.body, { childList: true, subtree: true });
  }
})();